import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Building2, CheckCircle2, Info, Package, Target } from 'lucide-react';
import type { ProjectDetails } from '@/types/project';

export const OverviewTab: React.FC<{ project: ProjectDetails }> = ({ project }) => {
  return (
    <>
      <Card>
        <CardHeader>
          <CardTitle className="text-lg flex items-center gap-2">
            <Building2 className="h-5 w-5" />
            Client Information
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          <div className="grid grid-cols-1 gap-4">
            <div>
              <p className="text-sm font-medium">Client Name</p>
              <p className="text-sm text-muted-foreground">{project.clientName}</p>
            </div>
            {project.clientContactName && (
              <>
                <div>
                  <p className="text-sm font-medium">Contact Person</p>
                  <p className="text-sm text-muted-foreground">{project.clientContactName}</p>
                </div>
                <div>
                  <p className="text-sm font-medium">Contact Email</p>
                  <p className="text-sm text-muted-foreground">{project.clientContactEmail}</p>
                </div>
              </>
            )}
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="text-lg flex items-center gap-2">
            <Target className="h-5 w-5" />
            Project Objectives
          </CardTitle>
        </CardHeader>
        <CardContent>
          <ul className="space-y-2">
            {project.objectives?.map((objective, index) => (
              <li key={index} className="flex items-start gap-2">
                <CheckCircle2 className="h-4 w-4 text-success-500 mt-0.5 flex-shrink-0" />
                <span className="text-sm">{objective}</span>
              </li>
            ))}
          </ul>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="text-lg flex items-center gap-2">
            <Package className="h-5 w-5" />
            Key Deliverables
          </CardTitle>
        </CardHeader>
        <CardContent>
          <ul className="space-y-2">
            {project.deliverables?.map((deliverable, index) => (
              <li key={index} className="flex items-start gap-2">
                <div className="h-2 w-2 rounded-full bg-primary mt-2 flex-shrink-0" />
                <span className="text-sm">{deliverable}</span>
              </li>
            ))}
          </ul>
        </CardContent>
      </Card>

      {project.specialInstructions && (
        <Card>
          <CardHeader>
            <CardTitle className="text-lg flex items-center gap-2">
              <Info className="h-5 w-5" />
              Special Instructions
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">
              {project.specialInstructions}
            </p>
          </CardContent>
        </Card>
      )}
    </>
  );
};
